var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flat-color-icons:sales-performance"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38 13C34.7 13 32 12.1 32 11V13C32 14.1 34.7 15 38 15C41.3 15 44 14.1 44 13V11C44 12.1 41.3 13 38 13Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M38 10C34.7 10 32 9.1 32 8V10C32 11.1 34.7 12 38 12C41.3 12 44 11.1 44 10V8C44 9.1 41.3 10 38 10ZM38 16C34.7 16 32 15.1 32 14V16C32 17.1 34.7 18 38 18C41.3 18 44 17.1 44 16V14C44 15.1 41.3 16 38 16Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M38 19C34.7 19 32 18.1 32 17V19C32 20.1 34.7 21 38 21C41.3 21 44 20.1 44 19V17C44 18.1 41.3 19 38 19Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M38 22C34.7 22 32 21.1 32 20V22C32 23.1 34.7 24 38 24C41.3 24 44 23.1 44 22V20C44 21.1 41.3 22 38 22Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M38 25C34.7 25 32 24.1 32 23V25C32 26.1 34.7 27 38 27C41.3 27 44 26.1 44 25V23C44 24.1 41.3 25 38 25Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M38 28C34.7 28 32 27.1 32 26V28C32 29.1 34.7 30 38 30C41.3 30 44 29.1 44 28V26C44 27.1 41.3 28 38 28Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M38 31C34.7 31 32 30.1 32 29V31C32 32.1 34.7 33 38 33C41.3 33 44 32.1 44 31V29C44 30.1 41.3 31 38 31Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M38 34C34.7 34 32 33.1 32 32V34C32 35.1 34.7 36 38 36C41.3 36 44 35.1 44 34V32C44 33.1 41.3 34 38 34Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M38 37C34.7 37 32 36.1 32 35V37C32 38.1 34.7 39 38 39C41.3 39 44 38.1 44 37V35C44 36.1 41.3 37 38 37Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M38 40C34.7 40 32 39.1 32 38V40C32 41.1 34.7 42 38 42C41.3 42 44 41.1 44 40V38C44 39.1 41.3 40 38 40Z",
    fill: "#FFA000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M38 10C41.3137 10 44 9.10457 44 8C44 6.89543 41.3137 6 38 6C34.6863 6 32 6.89543 32 8C32 9.10457 34.6863 10 38 10Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M38 12C35.2 12 32.9 11.4 32.2 10.5C32.1 10.7 32 10.8 32 11C32 12.1 34.7 13 38 13C41.3 13 44 12.1 44 11C44 10.8 43.9 10.7 43.8 10.5C43.1 11.4 40.8 12 38 12ZM38 15C35.2 15 32.9 14.4 32.2 13.5C32.1 13.7 32 13.8 32 14C32 15.1 34.7 16 38 16C41.3 16 44 15.1 44 14C44 13.8 43.9 13.7 43.8 13.5C43.1 14.4 40.8 15 38 15ZM38 18C35.2 18 32.9 17.4 32.2 16.5C32.1 16.7 32 16.8 32 17C32 18.1 34.7 19 38 19C41.3 19 44 18.1 44 17C44 16.8 43.9 16.7 43.8 16.5C43.1 17.4 40.8 18 38 18ZM38 21C35.2 21 32.9 20.4 32.2 19.5C32.1 19.7 32 19.8 32 20C32 21.1 34.7 22 38 22C41.3 22 44 21.1 44 20C44 19.8 43.9 19.7 43.8 19.5C43.1 20.4 40.8 21 38 21ZM38 24C35.2 24 32.9 23.4 32.2 22.5C32.1 22.7 32 22.8 32 23C32 24.1 34.7 25 38 25C41.3 25 44 24.1 44 23C44 22.8 43.9 22.7 43.8 22.5C43.1 23.4 40.8 24 38 24ZM38 27C35.2 27 32.9 26.4 32.2 25.5C32.1 25.7 32 25.8 32 26C32 27.1 34.7 28 38 28C41.3 28 44 27.1 44 26C44 25.8 43.9 25.7 43.8 25.5C43.1 26.4 40.8 27 38 27ZM38 30C35.2 30 32.9 29.4 32.2 28.5C32.1 28.7 32 28.8 32 29C32 30.1 34.7 31 38 31C41.3 31 44 30.1 44 29C44 28.8 43.9 28.7 43.8 28.5C43.1 29.4 40.8 30 38 30ZM38 33C35.2 33 32.9 32.4 32.2 31.5C32.1 31.7 32 31.8 32 32C32 33.1 34.7 34 38 34C41.3 34 44 33.1 44 32C44 31.8 43.9 31.7 43.8 31.5C43.1 32.4 40.8 33 38 33ZM38 36C35.2 36 32.9 35.4 32.2 34.5C32.1 34.7 32 34.8 32 35C32 36.1 34.7 37 38 37C41.3 37 44 36.1 44 35C44 34.8 43.9 34.7 43.8 34.5C43.1 35.4 40.8 36 38 36ZM38 39C35.2 39 32.9 38.4 32.2 37.5C32.1 37.7 32 37.8 32 38C32 39.1 34.7 40 38 40C41.3 40 44 39.1 44 38C44 37.8 43.9 37.7 43.8 37.5C43.1 38.4 40.8 39 38 39Z",
    fill: "#FFC107"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M10 19C6.7 19 4 18.1 4 17V19C4 20.1 6.7 21 10 21C13.3 21 16 20.1 16 19V17C16 18.1 13.3 19 10 19Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M10 16C6.7 16 4 15.1 4 14V16C4 17.1 6.7 18 10 18C13.3 18 16 17.1 16 16V14C16 15.1 13.3 16 10 16ZM10 22C6.7 22 4 21.1 4 20V22C4 23.1 6.7 24 10 24C13.3 24 16 23.1 16 22V20C16 21.1 13.3 22 10 22Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M10 25C6.7 25 4 24.1 4 23V25C4 26.1 6.7 27 10 27C13.3 27 16 26.1 16 25V23C16 24.1 13.3 25 10 25Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M10 28C6.7 28 4 27.1 4 26V28C4 29.1 6.7 30 10 30C13.3 30 16 29.1 16 28V26C16 27.1 13.3 28 10 28Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M10 31C6.7 31 4 30.1 4 29V31C4 32.1 6.7 33 10 33C13.3 33 16 32.1 16 31V29C16 30.1 13.3 31 10 31Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M10 34C6.7 34 4 33.1 4 32V34C4 35.1 6.7 36 10 36C13.3 36 16 35.1 16 34V32C16 33.1 13.3 34 10 34Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M10 37C6.7 37 4 36.1 4 35V37C4 38.1 6.7 39 10 39C13.3 39 16 38.1 16 37V35C16 36.1 13.3 37 10 37Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M10 40C6.7 40 4 39.1 4 38V40C4 41.1 6.7 42 10 42C13.3 42 16 41.1 16 40V38C16 39.1 13.3 40 10 40Z",
    fill: "#FFA000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M10 16C13.3137 16 16 15.1046 16 14C16 12.8954 13.3137 12 10 12C6.68629 12 4 12.8954 4 14C4 15.1046 6.68629 16 10 16Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M10 18C7.2 18 4.9 17.4 4.2 16.5C4.1 16.7 4 16.8 4 17C4 18.1 6.7 19 10 19C13.3 19 16 18.1 16 17C16 16.8 15.9 16.7 15.8 16.5C15.1 17.4 12.8 18 10 18ZM10 21C7.2 21 4.9 20.4 4.2 19.5C4.1 19.7 4 19.8 4 20C4 21.1 6.7 22 10 22C13.3 22 16 21.1 16 20C16 19.8 15.9 19.7 15.8 19.5C15.1 20.4 12.8 21 10 21ZM10 24C7.2 24 4.9 23.4 4.2 22.5C4.1 22.7 4 22.8 4 23C4 24.1 6.7 25 10 25C13.3 25 16 24.1 16 23C16 22.8 15.9 22.7 15.8 22.5C15.1 23.4 12.8 24 10 24ZM10 27C7.2 27 4.9 26.4 4.2 25.5C4.1 25.7 4 25.8 4 26C4 27.1 6.7 28 10 28C13.3 28 16 27.1 16 26C16 25.8 15.9 25.7 15.8 25.5C15.1 26.4 12.8 27 10 27ZM10 30C7.2 30 4.9 29.4 4.2 28.5C4.1 28.7 4 28.8 4 29C4 30.1 6.7 31 10 31C13.3 31 16 30.1 16 29C16 28.8 15.9 28.7 15.8 28.5C15.1 29.4 12.8 30 10 30ZM10 33C7.2 33 4.9 32.4 4.2 31.5C4.1 31.7 4 31.8 4 32C4 33.1 6.7 34 10 34C13.3 34 16 33.1 16 32C16 31.8 15.9 31.7 15.8 31.5C15.1 32.4 12.8 33 10 33ZM10 36C7.2 36 4.9 35.4 4.2 34.5C4.1 34.7 4 34.8 4 35C4 36.1 6.7 37 10 37C13.3 37 16 36.1 16 35C16 34.8 15.9 34.7 15.8 34.5C15.1 35.4 12.8 36 10 36ZM10 39C7.2 39 4.9 38.4 4.2 37.5C4.1 37.7 4 37.8 4 38C4 39.1 6.7 40 10 40C13.3 40 16 39.1 16 38C16 37.8 15.9 37.7 15.8 37.5C15.1 38.4 12.8 39 10 39Z",
    fill: "#FFC107"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M24 28C20.7 28 18 27.1 18 26V28C18 29.1 20.7 30 24 30C27.3 30 30 29.1 30 28V26C30 27.1 27.3 28 24 28Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M24 25C20.7 25 18 24.1 18 23V25C18 26.1 20.7 27 24 27C27.3 27 30 26.1 30 25V23C30 24.1 27.3 25 24 25ZM24 31C20.7 31 18 30.1 18 29V31C18 32.1 20.7 33 24 33C27.3 33 30 32.1 30 31V29C30 30.1 27.3 31 24 31Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M24 34C20.7 34 18 33.1 18 32V34C18 35.1 20.7 36 24 36C27.3 36 30 35.1 30 34V32C30 33.1 27.3 34 24 34Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M24 37C20.7 37 18 36.1 18 35V37C18 38.1 20.7 39 24 39C27.3 39 30 38.1 30 37V35C30 36.1 27.3 37 24 37Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M24 40C20.7 40 18 39.1 18 38V40C18 41.1 20.7 42 24 42C27.3 42 30 41.1 30 40V38C30 39.1 27.3 40 24 40Z",
    fill: "#FFA000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M24 25C27.3137 25 30 24.1046 30 23C30 21.8954 27.3137 21 24 21C20.6863 21 18 21.8954 18 23C18 24.1046 20.6863 25 24 25Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M24 27C21.2 27 18.9 26.4 18.2 25.5C18.1 25.7 18 25.8 18 26C18 27.1 20.7 28 24 28C27.3 28 30 27.1 30 26C30 25.8 29.9 25.7 29.8 25.5C29.1 26.4 26.8 27 24 27ZM24 30C21.2 30 18.9 29.4 18.2 28.5C18.1 28.7 18 28.8 18 29C18 30.1 20.7 31 24 31C27.3 31 30 30.1 30 29C30 28.8 29.9 28.7 29.8 28.5C29.1 29.4 26.8 30 24 30ZM24 33C21.2 33 18.9 32.4 18.2 31.5C18.1 31.7 18 31.8 18 32C18 33.1 20.7 34 24 34C27.3 34 30 33.1 30 32C30 31.8 29.9 31.7 29.8 31.5C29.1 32.4 26.8 33 24 33ZM24 36C21.2 36 18.9 35.4 18.2 34.5C18.1 34.7 18 34.8 18 35C18 36.1 20.7 37 24 37C27.3 37 30 36.1 30 35C30 34.8 29.9 34.7 29.8 34.5C29.1 35.4 26.8 36 24 36ZM24 39C21.2 39 18.9 38.4 18.2 37.5C18.1 37.7 18 37.8 18 38C18 39.1 20.7 40 24 40C27.3 40 30 39.1 30 38C30 37.8 29.9 37.7 29.8 37.5C29.1 38.4 26.8 39 24 39Z",
    fill: "#FFC107"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.d6bf12e611a787f283c9618a1fb03b78.svg";
export { ForwardRef as ReactComponent };